import { connect } from 'react-redux';
import { onClick } from './events/onClick';
import { IFakeNotificationsEvents } from '../../components/FakeNotifications/types';
import { FakeNotifications } from '../../components/FakeNotifications/FakeNotifications';

const mapDispatchToProps = (
    dispatch: any,
): IFakeNotificationsEvents => ({
    onClick: (isLast, isRead, type) => dispatch(onClick(isLast, isRead, type)),
});

export const FakeNotificationsHOC = connect(
    null,
    mapDispatchToProps,
)(FakeNotifications);

FakeNotificationsHOC.displayName = 'FakeNotificationsHOC';
